/* eslint-disable no-console */
import M from 'materialize-css/dist/js/materialize';
import * as actionsPabReplanning from '../actions/pabReplanningAction';
import PickingService from './PickingService';
import { endLoading, startLoading } from '../actions/loadingAction';
import { ENUMS, PERMISSIONS, VISIONS } from '../utils/constants';
import { getUrlExpeditionApi, isNullOrEmpty, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';
import { checkPermission, getUser, getVision } from './auth';

const httpService = new HttpService(getUrlExpeditionApi(window));

export default class PabReplanningService {
    static startOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/start`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPabReplanning.updateOrderStatus(orderId, ENUMS.eOrderStatus.InProgress.value));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static startOrderItem(orderId, orderItemId, callback) {
        const url = '/api/picking/mission/start';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, orderItemId }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPabReplanning.updateMissionStatus(orderItemId, ENUMS.eOrderItemStatus.InProgress.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    console.log('error on start orderItem', error);
                    if (callback) callback();
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static confirmPicking(orderItem, callback) {
        const url = '/api/picking';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, {
                    orderId: orderItem.orderId,
                    orderItemId: orderItem.orderItemId,
                    confirmMasterCim: orderItem.confirmMasterCim
                }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPabReplanning.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingFinish.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                showMessageToastCustom(translate('warning', 'general'), "Sem Conexão", 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        };
    }

    static getOrders(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/pab/orders';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(actionsPabReplanning.setOrders(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateOrderFromServer(order, changeUser) {
        return (dispatch) => {
            try {
                if (order) {
                    const manageOrder = checkPermission(PERMISSIONS.Expedition.Picking.ManageOrder);
                    const currentUser = getUser();
                    if ((!manageOrder && order.startedBy !== currentUser.userName)
                        || (order.status === ENUMS.eOrderStatus.Finished.value
                            || order.status === ENUMS.eOrderStatus.Canceled.value
                            || order.status === ENUMS.eOrderStatus.ManuallyFinished.value)) {
                    } else {
                        if (order.startedBy && order.startedBy.includes(currentUser.userName) && changeUser) {
                            if (VISIONS.Fiasa === getVision()) {
                                dispatch(actionsPabReplanning.updateOrder(order));
                                dispatch(actionsPabReplanning.selectOrder(order));
                                dispatch(PickingService.getMissions(order.orderId));
                                const url = `/api/lowering/userhasgroup?user=${currentUser.userName}`;
                                if (navigator.onLine) {
                                    httpService.instance.get(url).then((response) => {
                                        if (response.status === 200) {
                                            dispatch(actionsPabReplanning.setOrderReceived({
                                                order: order,
                                                showModalReceivedOrder: true,
                                                noHasGroup: response.data.data <= 0 ? true : false
                                            }));
                                        }
                                    }).catch((error) => {
                                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                                    });
                                }
                            } else {
                                showMessageToastCustom(translate('warning', 'general'), "Atenção! Nova tarefa atribuída a você.", 18000, 'mdi mdi-message-bulleted blue-text');
                            }
                        }
                    }
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static cancelOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    dispatch(actionsPabReplanning.removeOrder(order));
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static addOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    dispatch(actionsPabReplanning.addOrder(order));
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static getReport(filter, callback) {
        const url = '/api/pab/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getSuppliers(vision, pagination) {
        var filter = {};
        Object.assign(filter, pagination);
        const url = '/api/pab/suppliers';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter, paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPabReplanning.setSuppliers(response.data.data));
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getPartNumbers(filter, callback) {
        const url = '/api/pab/partnumbers';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter, paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPabReplanning.setPartNumbers(response.data.data));
                        if (callback) {
                            callback(response.data.data)
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static endCalls(data, vision, callback) {
        const url = '/api/pab/endCallsOrder';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data).then((response) => {
                    if (isNullOrEmpty(response.data.data)) {
                        showMessageToastCustom(translate('confirmed', 'general'), translate('line-picking:endCalls:message-success'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        let result = [];
                        var keys = Object.keys(response.data.data);
                        keys.map((key) => result.push({ code: key, message: response.data.data[key] }))
                        if (callback) {
                            callback(result);
                        }
                    }
                }).catch((error) => {
                    console.log('error on start orderItem', error);
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static getOrdersOpen(callback) {
        const url = '/api/pab/open';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        showMessageToastCustom(translate('confirmed', 'general'), translate('line-picking:endCalls:message-success'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        callback(response.data.data);

                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static confirmationPabAllocation(model, callback) {
        const url = '/api/pab/confirmation';
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(url, model).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback(response.data?.data);
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        }
    }

    static setArea(area) {
        return (dispatch) => { dispatch(actionsPabReplanning.setArea(area)); };
    }

    static setSectors(sectors) {
        return (dispatch) => { dispatch(actionsPabReplanning.setSectors(sectors)); };
    }
}